module.exports = __webpack_public_path__ + "img/caja6.68b6cba2.png";